import React, { Component } from 'react';
import { connect } from 'react-redux';
//import { Map } from 'immutable';
import { updateInterpolationGrid } from '../../actions/uitool';

class GridToolComp extends Component {

  constructor(props) {
    super(props);

    this.state = {
      cellValid: true,
      weightValid: true,
      cellValue: props.gridCellSize,
      weightValue: props.distanceWeightingFactor
    }
  }

  handleUpdate() {
    this.props.dispatch(updateInterpolationGrid(this.state.cellValue, this.state.weightValue));
  }

  handleCellSizeChange(e) {
    var value = e.target.value;
    if(parseFloat(+value, 10) > 0.099999999999 && parseFloat(+value, 10) < 10.0000000000001 ) {
      this.setState({cellValid: true, cellValue: parseFloat(+value, 10)})
    } else {
      this.setState({cellValid: false, cellValue: value})
    }
  }

  handleWeightingFactorChange(e) {
    var value = e.target.value;
    if(parseInt(+value, 10) < 11 && parseInt(+value, 10) > 0 && !isNaN(parseInt(+value, 10))) {
      this.setState({weightValid: true, weightValue: parseInt(+value, 10)})
    } else {
      this.setState({weightValid: false, weightValue: value})
    }
  }

  render() {
    
    var cellSize = this.state.cellValue;
    var weight = this.state.weightValue;

    return (
      <div style={{paddingTop: '5px', marginTop: '7px', borderTop: '1px solid'}}>
        <h5>IDW Interpolation Grid</h5>
        <div className="form-group has-danger">
          <label className="form-control-label">Grid Cell Size (in kilometers)</label>
          <input type="text" value={cellSize} className={this.state.cellValid ? "form-control" : "form-control is-invalid"} onChange={this.handleCellSizeChange.bind(this)}/>
          { !this.state.cellValid ? (<div className="invalid-feedback">Please use a positive no more than 10 km and at least 0.1 km.</div>) : null }
        </div>
        <div className="form-group has-danger">
          <label className="form-control-label">Distance Weighting Factor</label>
          <input type="text" value={weight} className={this.state.weightValid ? "form-control" : "form-control is-invalid"} onChange={this.handleWeightingFactorChange.bind(this)}/>
          { !this.state.weightValid ? (<div className="invalid-feedback">Please use an integer from 1 - 10.</div>) : null }
        </div>
        <button disabled={!this.state.cellValid || !this.state.weightValid} type="submit" className={this.state.cellValid && this.state.weightValid ? "btn btn-primary" : "btn btn-primary disabled"} onClick={this.handleUpdate.bind(this)}>Update</button>
      </div>
    )
  }
}

function mapStateToProps(state){
  return {
    gridCellSize: state.uiApp.get('gridCellSize'),
    distanceWeightingFactor: state.uiApp.get('distanceWeightingFactor')
  }
}

const GridTool = connect(mapStateToProps)(GridToolComp);

export default GridTool;


// WEBPACK FOOTER //
// ./src/components/uiTool/GridTool.js